import { useEffect, useRef, useState } from 'react';
var scripts = new Map();
export function addScript(src, init) {
    var existing = scripts.get(src);
    if (existing) {
        return existing;
    }
    var script = document.createElement('script');
    script.src = src;
    script.async = true;
    document.getElementsByTagName('head')[0].appendChild(script);
    var promise = new Promise(function (resolve) {
        script.addEventListener('load', function () {
            var result = init && init();
            resolve(result);
        });
    });
    scripts.set(src, promise);
    return promise;
}
export function useScript(src, init) {
    var _a = useState(), loaded = _a[0], setLoaded = _a[1];
    var initRef = useRef(init);
    useEffect(function () {
        addScript(src, initRef.current).then(function (result) {
            setLoaded(result !== null && result !== void 0 ? result : true);
        });
    }, [src]);
    return loaded;
}
//# sourceMappingURL=useScript.js.map